<template>
  <div>
    <!--    기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :options="[{ type: 'alert', label: '알림 대상자 선택' }]" />

    <!-- 화학물질(작업환경측정 대상) 취급대장 -->
    <usage-history-module :readonly="board.readonly" v-model="form.msds" :is-print="isPrint" />

    <!-- 확인자 -->
    <div>
      <div>
        <h5><i class="dot"></i>{{ $t('확인자') }}</h5>
        <p class="py-4" style="color: #696d71">{{ $t('위 화학물질에 대한 취급내용을 확인 하였습니다.') }}</p>
      </div>
      <div class="writeGridContainer" style="align-items: start">
        <div>
          <div>{{ $t('확인일') }}</div>
          <date-selector v-if="!isPrint" v-model="form.sign.date" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign.date }}</span>
        </div>
        <div>
          <div>{{ $t('관리감독자') }}</div>
          <ml-input v-if="!isPrint" v-model="form.sign.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign.name }}</span>
        </div>
        <div style="align-items: start">
          <div class="pt-2">{{ $t('서명') }}</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign.sign" :src="form.sign.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 안내문구 -->
    <div class="p-3 mb-8 border-top border-left border-right border-bottom" style="background: #fafafa">
      <p>{{ $t('&lt;참고&gt; 산업안전보건기준에 관한 규칙 제420조(정의)') }}</p>
      <p style="display: flex; align-items: center"><i class="dot small black"></i>{{ $t('임시작업 : 일시적으로 하는 작업 중 월24시간 미만인 작업을 말함. 단, 월10시간 이상 24시간 미만인 작업이 매월 행하는 작업 제외') }}<br /></p>
      <p style="display: flex; align-items: center"><i class="dot small black"></i>{{ $t('단시간작업 : 관리대상 유해물질을 취급하는 시간이 1일 1시간 미만인 작업을 말함. 단, 1일 1시간 미만인 작업이 매일 수행되는 경우 제외') }}<br /></p>
    </div>

    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule.vue";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import UsageHistoryModule from "@/views/boards/single-page/400/UsageHistoryModule.vue";
import SignField from "@/components/SignField.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {
    DateSelector,
    SignField,
    UsageHistoryModule,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(/*value*/) {},
    },
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  computed: {
    projectInfo() {
      return this.$store.state.project.projectInfo;
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        msds: [],
        fileList: [],
        sign: {
          date: "",
          name: "",
          sign: "",
        },
      },
    };
  },
  methods: {},
};
</script>

<style scoped></style>
